export default __webpack_public_path__ + "static/voucher-3028cc9792294922cdb8656865814bdd.png";